import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const OwnProgressTrackingLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.graph_humanum_menu_link',
    link: '/graph-humanum/single/own-progress',
    icon: 'navigation-link__own_progress-tracking',
});